<template>
  <v-snackbar :timeout="0" v-model="offline" color="#fd222c" top centered>
    <v-col class="pt-1">
      <v-row>
        <v-icon class="mt-1 mr-1">$iconWarning</v-icon>
        <p class="subtitle-1">{{ $t("offline-notification.title") }}</p>
      </v-row>
      <v-row>
        <p class="body2 mt-2">
          {{ $t("offline-notification.instructions") }}
        </p>
      </v-row>
    </v-col>
  </v-snackbar>
</template>
<script>
export default {
  name: "internet-connection-banner",
  data: () => ({
    offline: false,
    checkInternet: null,
  }),
  created() {
    this.checkInternet = setInterval(() => {
      this.offline = !window.navigator.onLine;
    }, 500);
  },
  destroyed() {
    clearInterval(this.checkInternet);
  },
};
</script>
